/* istanbul ignore file */
import api from '../axios';
import { getApiUrl, getV4ApiConfig } from '../helpers';
import { getSession } from './blg';
import { LeadingBreak, LeadingBreakData } from '../../helpers/aggregating/leading-breaks';
import {
  GroupedAccommodationFeatures,
  UngroupedAccommodationFeatures,
} from '../../types/accommodation-features';

const url = getApiUrl();
const axios = api(url);

const v4ApiConfig = getV4ApiConfig();
const v4axios = api(v4ApiConfig.url, { apiKey: v4ApiConfig.apiKey, domain: v4ApiConfig.domain });

export const getParksData = async (query: Record<string, unknown>) => {
  try {
    return await axios.get('/holiday-parks', {
      query,
    });
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getAffiliatePricing = async (params: {
  packageId: string;
  grade: string;
  dogCount: number;
  guestCount: number;
  parkCode: string;
  duration: number;
  arrivalDate: string;
}) => {
  try {
    const sessionId = await getSession();

    const result = await axios.get(`/affiliate/pricing`, {
      headers: {
        'x-bl-rds': sessionId,
      },
      query: { ...params },
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const putBLGAgency = async (body: Record<string, unknown>) => {
  try {
    const sessionId = await getSession();

    const result = await axios.put(`/affiliate/agency`, {
      body,
      headers: {
        'x-bl-rds': sessionId,
      },
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const putBLGOfferCode = async (body: Record<string, unknown>) => {
  try {
    const sessionId = await getSession();

    const result = await axios.put(`/affiliate/offercode`, {
      body,
      headers: {
        'x-bl-rds': sessionId,
      },
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const deleteBLGOfferCode = async () => {
  try {
    const sessionId = await getSession();

    const result = await axios.delete(`/affiliate/offercode`, {
      headers: {
        'x-bl-rds': sessionId,
      },
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getCampaignDetails = async (params: Record<string, unknown>) => {
  try {
    const sessionId = await getSession();

    const result = await axios.get(`/affiliate/campaign`, {
      headers: {
        'x-bl-rds': sessionId,
      },
      query: { ...params },
    });

    return {
      AgencyID: result?.AgencyID,
      PromoCode: result?.PromoCode,
    };
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getLeadingBreaks = async (
  query: Record<string, unknown>,
): Promise<{ items: LeadingBreak[] }> => {
  try {
    return await axios.get(`/leading-breaks`, {
      query,
    });
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getLeadingBreaksData = async (
  query: Record<string, unknown>,
): Promise<{ items: LeadingBreakData[] }> => {
  try {
    return await v4axios.get(`/leading-breaks`, {
      query,
    });
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const signalPackageReserveV4 = async (params: {
  packageId: string;
  grade: string;
  duration: number;
  arrivalDate: string;
  parkCode: string;
}) => {
  try {
    const result = await v4axios.post(`/signal-package-reserve`, {
      body: params,
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const signalPackageReserve = async (params: {
  packageId: string;
  grade: string;
  duration: number;
  arrivalDate: string;
  parkCode: string;
}) => {
  try {
    const result = await axios.post(`/signal-package-reserve`, {
      body: params,
    });

    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getReasonsToBook = async () => {
  try {
    const result = await axios.get(`/reasons-to-book`, {});
    return result;
  } catch (ex) {
    return Promise.reject(ex);
  }
};

export const getAccommodationFeatures = async (
  query: Record<string, unknown>,
): Promise<GroupedAccommodationFeatures | UngroupedAccommodationFeatures> => {
  try {
    return await axios.get(`/accommodation-features`, {
      query,
    });
  } catch (ex) {
    return Promise.reject(ex);
  }
};
